// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var introSection = "ascenza-module--introSection--s8012";
export var introImage = "ascenza-module--introImage--jcFbA";
export var introSmallDescription = "ascenza-module--introSmallDescription--3uVGg";
export var description = "ascenza-module--description--kWNFr";
export var body = "ascenza-module--body--3FM5v";
export var statmentsContainer = "ascenza-module--statmentsContainer--wiQFA";
export var statmentContent = "ascenza-module--statmentContent--2J3fG";
export var statment = "ascenza-module--statment--1My0_";
export var statmentImageContainer = "ascenza-module--statmentImageContainer--2hynp";
export var statmentTitle = "ascenza-module--statmentTitle--3_1BF";
export var statmentDescription = "ascenza-module--statmentDescription--1Yho6";
export var statmentImage = "ascenza-module--statmentImage--1ZuD2";
export var wrapper = "ascenza-module--wrapper--24P06";
export var greenCircles = "ascenza-module--greenCircles--EhGWM";
export var purposeContainer = "ascenza-module--purposeContainer--jbZxS";
export var video = "ascenza-module--video--14N8L";
export var buttonWrapper = "ascenza-module--buttonWrapper--Vf-KE";
export var hidden = "ascenza-module--hidden--2tzxx";
export var button = "ascenza-module--button--2Tw0F";
export var disabled = "ascenza-module--disabled--1qO3l";